import React from 'react'
import { Modal } from '../ui'
import { errorIcon, thankyouIcon } from '../../assets/images'

export default function SaveAsDraftModal({
    error=false,
    handleCloseModal=() => {}
}) {
  return (
    <Modal 
        modalTitle='Confirmation' 
        footerActionActive 
        footerActionText='Okay' 
        footerAction={handleCloseModal} 
        handleCloseModal={handleCloseModal}
        className='save-draft-modal'
    >
        <img src={error ? errorIcon : thankyouIcon} alt="" />
        <h6>Your draft is {error ? 'not' : ''} saved</h6>
        <p>
            {error ? "Please make sure to save your work to avoid losing any progress." :
            "You can return to it anytime and continue where you left off, with all your progress secure."}
        </p>
    </Modal>
  )
}
